import React from "react";
import {withApollo} from "config/apolloConfig";
import Reset from "views/auth/resetPassword/ResetPassword";

const ResetPage = () => {
    return <Reset/>
}

export default withApollo({ssr: true})(ResetPage);